export const dayOptions = [
  {
    title: "Monday",
    link: "/app/causessettings",
    state: { type: "personal" },
    iconKey: "check",
  },
  {
    title: "Tuesday",
    link: "/app/settings/teams",
    iconKey: "check",
  },
  {
    title: "Wednesday",
    link: "/app/managesubscription",
    iconKey: "check",
  },
  {
    title: "Thursday",
    link: "/app/managesubscription",
    iconKey: "check",
  },
  {
    title: "Friday",
    link: "/app/managesubscription",
    iconKey: "check",
  },
];

export const weekDayOptions = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];
